export default __webpack_public_path__ + "static/media/DesignInstructions.861e2fce.png";